import css from 'styled-jsx/css';

export default css.global`@keyframes ldio-d52igmd3au {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.ldio-d52igmd3au div {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 2px solid #e15b64;
  border-top-color: transparent;
  border-radius: 50%;
}
.ldio-d52igmd3au div {
  animation: ldio-d52igmd3au 1s linear infinite;
  top: 50%;
  left: 50%;
}
.loadingio-spinner-rolling-q6gvtqfmm3j {
  width: 50px;
  height: 50px;
  display: inline-block;
  overflow: hidden;
  background: transparent;
}
.ldio-d52igmd3au {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-d52igmd3au div {
  box-sizing: content-box;
}

.loader-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
}
`